/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VmAgentsQueryInstantState extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("VmAgentsQueryInstantState");
    }

    getFixupPrototypeFunction() { return VmAgentsQueryInstantState.fixupPrototype; }

    static newInstance(model: Partial<VmAgentsQueryInstantState>): VmAgentsQueryInstantState {
        let obj = Object.assign(new VmAgentsQueryInstantState(), model);
        VmAgentsQueryInstantState.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VmAgentsQueryInstantState>): VmAgentsQueryInstantState {
        if (!model) return null;
        return VmAgentsQueryInstantState.newInstance(<VmAgentsQueryInstantState> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VmAgentsQueryInstantState) {
        if (!obj) return;

        models.VmAgentsQueryInstantState.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VmAgentsQueryInstantState): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, VmAgentsQueryInstantState.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * State of Instances
     */
    instant_state: Array<models.InstanceState>;

}
